(async () => {
  let stores = window.BROWNDOG_RETAILERS || [];
  const form = document.querySelector('#store-search');
  const results = document.querySelector('#store-results');
  const status = document.querySelector('#store-status');
  const map = document.querySelector('#store-map');
  const selected = document.querySelector('#store-selected');
  let request = 0;
  if (!window.BROWNDOG_RETAILERS && (typeof BSS_SL_metaobject === 'undefined' || !BSS_SL_metaobject.storefrontAccessToken)) {status.textContent='Store locations are temporarily unavailable. Please try again shortly.';form.querySelector('button').disabled=true;return;}
  if (typeof BSS_SL_metaobject !== 'undefined' && BSS_SL_metaobject.storefrontAccessToken && typeof BSS_SL !== 'undefined') {
    form.querySelector('button').disabled=true;
    status.textContent='Loading current store locations…';
    try {
      const versions=Number(BSS_SL.maxVersion)||0;
      const fields=Array.from({length:versions||1},(_,i)=>{const version=versions?i+1:0;return `v${version}: metaobject(handle: {handle: "bss_sl_metaobject_data", type: "$app:bss_sl_data${version?'_v'+version:''}"}) { fields { key value } }`;}).join(' ');
      const response=await fetch(`/api/${BSS_SL_metaobject.apiVersion}/graphql.json`,{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':BSS_SL_metaobject.storefrontAccessToken},body:JSON.stringify({query:`{ ${fields} }`}),signal:AbortSignal.timeout(15000)});
      if(!response.ok)throw Error('Locations unavailable');
      const payload=await response.json();if(payload.errors)throw Error('Location query failed');
      const records=[];
      for(const entry of Object.values(payload.data||{})){
        if(!entry)throw Error('Missing location data');
        for(const field of entry.fields||[]){
          if(field.key.startsWith('locations_'))records.push(...JSON.parse(field.value).data||[]);
          else if(!versions){const value=JSON.parse(field.value);if(value.key?.includes('storeLocators'))records.push(...JSON.parse(value.value));}
        }
      }
      stores=records.filter(s=>Number(s.active)===1&&!s.deletedAt&&Number.isFinite(Number(s.lat))&&Number.isFinite(Number(s.lng))&&s.lat!==null&&s.lng!==null).map(s=>({name:s.storeName,address:s.address,city:s.city,state:s.state,zip:String(s.zipCode||'').slice(0,5),phone:s.phone,lat:Number(s.lat),lng:Number(s.lng)}));
      status.textContent='Search your ZIP code to find nearby retailers.';
    } catch(error) {
      status.textContent='We couldn’t load current store locations. Please refresh to try again.';
      return;
    } finally {form.querySelector('button').disabled=false;}
  }

  const distance = (a, b) => {
    const rad = n => n * Math.PI / 180;
    const h = Math.sin(rad(b.lat-a.lat)/2)**2 + Math.cos(rad(a.lat))*Math.cos(rad(b.lat))*Math.sin(rad(b.lng-a.lng)/2)**2;
    return 3958.8 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1-h));
  };
  function showStore(store, button) {
    results.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    selected.textContent = `${store.name} · ${store.address}, ${store.city}`;
    const box = [store.lng-.025, store.lat-.018, store.lng+.025, store.lat+.018].join(',');
    map.src = `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(box)}&layer=mapnik&marker=${store.lat},${store.lng}`;
    map.title = `Map of ${store.name}, ${store.city}`;
  }
  function render(list) {
    results.replaceChildren();
    for (const store of list) {
      const card = document.createElement('article');
      const button = document.createElement('button');
      button.type = 'button'; button.setAttribute('aria-pressed','false');
      const heading = document.createElement('strong'); heading.textContent = store.name;
      const address = document.createElement('span'); address.textContent = `${store.address}, ${store.city}, ${store.state} ${store.zip}`;
      const miles = document.createElement('small'); miles.textContent = store.distance == null ? 'View on map →' : `${store.distance.toFixed(1)} miles · View on map →`;
      button.append(heading,address,miles); button.addEventListener('click', () => showStore(store, button));card.append(button);
      if (store.phone) { const phone = document.createElement('a'); phone.href = 'tel:'+store.phone.replace(/[^+\d]/g,'');phone.textContent=store.phone;card.append(phone); }
      results.append(card);
    }
    if (list.length) showStore(list[0],results.querySelector('button'));
    else { selected.textContent='No stores in this search area. Try a wider radius.'; map.src='about:blank'; }
  }
  render(stores.slice().sort((a,b)=>a.name.localeCompare(b.name)));
  form.addEventListener('submit', async event => {
    event.preventDefault(); const id = ++request;
    const zip = document.querySelector('#store-zip').value.trim();
    const radius = Number(document.querySelector('#store-radius').value);
    status.textContent = 'Finding your nearby scoops…';
    try {
      const response = await fetch(`https://api.zippopotam.us/us/${zip}`, {signal:AbortSignal.timeout(8000)});
      if (!response.ok) throw new Error('zip');
      const data = await response.json(); if(id !== request)return;
      const place = data.places[0]; const origin = {lat:Number(place.latitude),lng:Number(place.longitude)};
      const list = stores.map(s=>({...s,distance:distance(origin,s)})).filter(s=>s.distance<=radius).sort((a,b)=>a.distance-b.distance);
      render(list); status.textContent = list.length ? `${list.length} retailers within ${radius} miles of ${zip}. Distances are approximate, measured from the ZIP area center.` : `No retailers within ${radius} miles of ${zip}. Try a wider radius, or build a box for delivery below.`;
    } catch(error) {
      if(id !== request)return;
      const exact=stores.filter(s=>s.zip===zip);render(exact);
      status.textContent=exact.length ? `Showing ${exact.length} stores in ${zip}. Nearby-distance search is temporarily unavailable.` : 'We could not look up this ZIP code. Check the five digits and your internet connection, then try again.';
    }
  });
})();
